import apiClient from '../../services/apiClient';
import type { FeedbackCategory, FeedbackMessageRow, FeedbackStatus } from './types';

export interface SubmitFeedbackInput {
  category: FeedbackCategory;
  body: string;
  is_anonymous: boolean;
  class_session_id?: string | null;
}

export async function submitFeedback(input: SubmitFeedbackInput): Promise<{ id: string }> {
  const { data } = await apiClient.post('/api/v1/feedback', input);
  return data;
}

// Instructor ------------------------------------------------------------------

export async function listFeedback(status?: FeedbackStatus): Promise<FeedbackMessageRow[]> {
  const { data } = await apiClient.get<{ messages: FeedbackMessageRow[] }>('/api/v1/feedback', {
    params: status ? { status } : undefined,
  });
  return data.messages;
}

export async function updateFeedback(
  id: string,
  patch: { status?: FeedbackStatus; instructor_note?: string | null },
): Promise<FeedbackMessageRow> {
  const { data } = await apiClient.put(`/api/v1/feedback/${id}`, patch);
  return data.message;
}

// Best-effort lookup of today's class session, purely to offer the optional
// "about today's class" toggle on the feedback box. Owned by WS-C
// (routes/classSessions.js) — this is a plain read of a documented public
// endpoint, not a dependency on that workstream's feature module. Any failure
// (route not mounted yet, feature off, no session today) just hides the toggle.
export async function todaysSessionId(): Promise<{ id: string; label: string } | null> {
  try {
    const { data } = await apiClient.get('/api/v1/class-sessions/today');
    if (data && data.session && data.session.id) {
      return { id: data.session.id, label: data.session.label };
    }
    return null;
  } catch {
    return null;
  }
}
